import { useParams } from 'react-router-dom';
import DSBox from '../../../design-system/DSBox';
import KlydoPreview from '../../../components/klydoPreview/KlydoPreview';
import usePublicKlydoQuery from '../hooks/usePublicKlydoQuery';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import useResponsiveClockScale from '../hooks/useResponsiveClockScale';

const commonBoxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundColor: '#1E1E1E',
  overflowX: 'hidden',
  overflowY: 'auto',
  boxSizing: 'border-box',
  padding: {
    xs: '8px 16px',
    sm: '40px',
    md: '60px',
  },
} as const;

const PublicKlydoView = (): JSX.Element => {
  const { klydoId } = useParams<{ klydoId: string }>();

  const { data: klydo, isLoading, error } = usePublicKlydoQuery(klydoId || '');
  const scale = useResponsiveClockScale();

  if (isLoading) {
    return (
      <DSBox sx={commonBoxStyles}>
        <DSCircularProgress />
      </DSBox>
    );
  }

  if (error || !klydo) {
    return (
      <DSBox
        sx={{
          ...commonBoxStyles,
          color: '#FFFFFF',
          fontSize: {
            xs: '14px',
            sm: '16px',
          },
          textAlign: 'center',
        }}
      >
        <p>
          {error?.response?.data?.message ||
            error?.message ||
            'Klydo not found'}
        </p>
      </DSBox>
    );
  }

  return (
    <DSBox sx={commonBoxStyles}>
      {/* No menuButtonItemsList - ensures no buttons appear */}
      <KlydoPreview
        klydo={klydo}
        backgroundHidden={false}
        dialsHidden
        scale={scale}
      />
    </DSBox>
  );
};

export default PublicKlydoView;
